/* eslint-disable */
export default {
  unknown: 'Desconocido',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
